import React, {useState, useEffect} from 'react'
import Select from 'react-select'
import Flatpickr from 'react-flatpickr'
import {getEquipe, getEquipeUtilisateur, horaireEquipe} from '../../../components/requests'
import {ModeleEditEquipe} from '../../../components/Models'
import {dayOrder, extractedHour, getCurrentHour, getDayLabel} from '../../../components/renders'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
import {useLocation} from 'react-router'

interface LocationState {
  equipe: ModeleEditEquipe
}

const HorairePage = () => {
  const [heureDebut, setHeureDebut] = useState<any>({time: '08:00'})
  const [heureFin, setHeureFin] = useState<any>({time: '18:00'})
  const [heureDebutPause, setHeureDebutPause] = useState<any>()
  const [heureFinPause, setHeureFinPause] = useState<any>()
  const [equipes, setEquipes] = useState<Array<ModeleEditEquipe>>([])
  const [equipeLoader, setEquipeLoader] = useState<boolean>(false)
  const [selectedEquipe, setSelectedEquipe] = useState<any>([])
  const navigate = useNavigate()
  const [configTime, setConfigTime] = useState<boolean>(false)
  const [selectedDay, setSelectedDay] = useState<any>([])
  const [heureSpec, setHeureSpec] = useState<any>([])
  const [loadingOnSave, setLoadingOnSave] = useState<boolean>(false)
  const location = useLocation()
  const state = location.state as LocationState | null
  const [disableSaveBtn, setDisableSaveBtn] = useState<boolean>(false)

  const getAllEquipe = () => {
    setEquipeLoader(true)
    getEquipeUtilisateur()
      .then((request) => {
        if (request?.data !== undefined && request?.status === 200) {
          const transformedData = request.data.map((item) => ({
            value: item.id,
            label: item.nom,
          }))
          setEquipes([...transformedData])
          setEquipeLoader(false)
        }
      })
      .catch((e) => {
        setEquipeLoader(false)
        console.error('erreur: ', e)
      })
  }
  const getEquipeData = async () => {
    setEquipeLoader(true)

    try {
      const res = await getEquipe(state?.equipe?.value)

      if (res?.status !== 200 || !res?.data) {
        return
      }

      const { data } = res

      setHeureDebut({
        time: extractedHour(data?.heureDebut),
      })

      setHeureFin({
        time: extractedHour(data?.heureFin),
      })

      setHeureDebutPause({
        time: extractedHour(data?.heureDebutPause),
      })

      setHeureFinPause({
        time: extractedHour(data?.heureFinPause),
      })

      const specificDays = Object.keys(data?.specificDay ?? {})

      if (specificDays.length > 0) {
        setHeureSpec(data.specificDay)
        setSelectedDay(specificDays)
      }
    } catch (e) {
      console.error('Erreur lors de la récupération de l’équipe :', e)
    } finally {
      setEquipeLoader(false)
    }
  }

  // Désacitvé le bouton de save si aucun équipe séléctionné
  // Désacitvé le bouton de save si heure ouverture et fermeture identique
  useEffect(function disableSave() {
    if ((heureDebut.time === heureFin.time) || selectedEquipe?.length === 0)
      setDisableSaveBtn(true)
    else
      setDisableSaveBtn(false)
  }, [heureDebut, heureFin, selectedEquipe])

  useEffect(function fetchAllEquipe() {
    if (state?.equipe) { // Modification Horaire
      setEquipes([
        {
          value: state?.equipe?.value,
          label: state?.equipe?.label,
        },
      ])
      setSelectedEquipe([state?.equipe?.value])
      getEquipeData()
    } else { // Création Horaire
      getAllEquipe()
    }
  }, [state])

  useEffect(function configTimeForEquipe(){
    if (!state?.equipe) {
      if (configTime) {
        const heureDeb = state?.equipe ? heureDebut : {time: '08:00'}
        const heureFn = state?.equipe ? heureFin : {time: '18:00'}
        setHeureDebut(heureDeb)
        setHeureFin(heureFn)
      } else {
        setHeureDebut({time: '08:00'})
        setHeureFin({time: '18:00'})
      }
    }
  }, [configTime])

  // useEffect(function checkConfigTimeIfHourChange(){
  //   if (heureDebut.time !== '00:00'|| heureFin.time !== '00:00')
  //     setConfigTime(true)
  // }, [heureDebut, heureFin])


  const handleHourSave = (e: React.FormEvent) => {
    e.preventDefault()
    setLoadingOnSave(true)
    if (!heureDebut || !heureFin) return

    horaireEquipe(selectedEquipe, heureDebut, heureFin, heureDebutPause, heureFinPause, heureSpec).then((res) => {
      if (res?.data && res?.status === 200) {
        setLoadingOnSave(false)

        toast.success('Horaire configurer avec succès')
        navigate(`/equipes/liste`)
      } else {
        setLoadingOnSave(false)

        toast.error("Echec configuration de l'horaire")
      }
    })
  }

  const checkSpecificDay = (value, isChecked) => {
    setSelectedDay((prev) => {
      if (isChecked) {
        return [...prev, value]
      } else {
        return prev.filter((d) => d !== value)
      }
    })

    if (!isChecked) {
      setHeureSpec((prev) => {
        const updated = {...prev}
        delete updated[value]
        return updated
      })
    }
  }

  const renderSpecificDay = () => {
    const day = [
      {value: 'LUN', label: 'Lundi'},
      {value: 'MAR', label: 'Mardi'},
      {value: 'MER', label: 'Mercredi'},
      {value: 'JEU', label: 'Jeudi'},
      {value: 'VEN', label: 'Vendredi'},
    ]

    return (
      <>
        {day?.map((d, index) => (
          <div className='form-check form-check-custom form-check-solid form-check-sm'>
            <input
              className='form-check-input'
              type='checkbox'
              value={d.value}
              id={d.value}
              checked={selectedDay?.includes(d.value)}
              onChange={(e) => checkSpecificDay(e.target.value, e.target.checked)}
            />
            <label className='form-check-label' htmlFor={d.value}>
              {d?.label}
            </label>
          </div>
        ))}
      </>
    )
  }

  const dayLabels = {
    LUN: 'Lundi',
    MAR: 'Mardi',
    MER: 'Mercredi',
    JEU: 'Jeudi',
    VEN: 'Vendredi',
  }

  useEffect(
    function deleteHeureSpec() {
      if (selectedDay?.length === 0) {
        setHeureSpec([])
      }
    },
    [selectedDay]
  )

  useEffect(
    function checkIfHeureSpecDefined() {
      const incompleteDays = selectedDay?.filter((dayValue) => {
        const heureDebut = heureSpec?.[dayValue]?.heureDebut
        const heureFin = heureSpec?.[dayValue]?.heureFin
        // XOR : une des deux heures est définie, mais pas l'autre
        return (!!heureDebut && !heureFin) || (!heureDebut && !!heureFin)
      })

      if (incompleteDays?.length > 0) {
        setDisableSaveBtn(true)
      } else {
        setDisableSaveBtn(false)
      }
    },
    [heureSpec, selectedDay]
  )
  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>
              Configurer l'horaire de l'équipe{' '}
              <span className={'text-primary'}>{state?.equipe?.label}</span>
            </h3>
          </div>
        </div>
        {!equipeLoader ? (
          <>
            <form onSubmit={handleHourSave}>
              <div className='card-body border-top p-9'>
                {!state?.equipe && (
                  <>
                    <div className='row mb-6'>
                      <label className={`col-lg-4 col-form-label required fw-bold fs-6`}>
                        Equipes
                      </label>
                      <div className='col-lg-8 fv-row'>
                        <Select
                          className='react-select-styled react-select-solid react-select-lg'
                          classNamePrefix='react-select'
                          options={equipes}
                          fieldName='equipes'
                          placeholder='Sélectionner équipes'
                          isMulti
                          value={equipes?.filter((eq) => selectedEquipe?.includes(eq?.value))}
                          onChange={(e) => setSelectedEquipe(e ? e.map((opt) => opt?.value) : [])}
                          required
                          isLoading={equipeLoader}
                          isDisabled={!!state?.equipe}
                        />
                      </div>
                    </div>
                  </>
                )}
                <div className='row'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>Horaire</label>
                  <div className='col-lg-8'>
                    <div className='row mb-3'>
                      <div className='col-lg-6 fv-row'>
                        <Flatpickr
                          value={heureDebut?.time}
                          onChange={([time], dateStr) => {
                            setHeureDebut({time: dateStr})
                          }}
                          options={{
                            enableTime: true,
                            noCalendar: true,
                            dateFormat: 'H:i',
                            time_24hr: true,
                            defaultHour: '08',
                          }}
                          className='form-control form-control-solid'
                          placeholder='Heure début'
                          name='horaireDebut'
                        />
                      </div>

                      <div className='col-lg-6 fv-row'>
                        <Flatpickr
                          value={heureFin?.time}
                          onChange={([time], dateStr) => {
                            setHeureFin({time: dateStr})
                          }}
                          options={{
                            enableTime: true,
                            noCalendar: true,
                            dateFormat: 'H:i',
                            minTime: heureDebut?.time || undefined,
                            time_24hr: true,
                            defaultHour: '18',
                          }}
                          className='form-control form-control-solid'
                          placeholder='Heure fin'
                          name='horaireFin'
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>Pause</label>
                  <div className='col-lg-8'>
                    <div className='row mb-3'>
                      <div className='col-lg-6 fv-row'>
                        <Flatpickr
                          value={heureDebutPause?.time}
                          onChange={([time], dateStr) => {
                            setHeureDebutPause({time: dateStr})
                          }}
                          options={{
                            enableTime: true,
                            noCalendar: true,
                            dateFormat: 'H:i',
                            time_24hr: true,
                            minTime: heureDebut?.time || undefined,
                            maxTime:  heureFinPause?.time || heureFin?.time
                          }}
                          className='form-control form-control-solid'
                          placeholder='Heure début pause'
                          name='horaireDebutPause'
                        />
                      </div>

                      <div className='col-lg-6 fv-row'>
                        <Flatpickr
                          value={heureFinPause?.time}
                          onChange={([time], dateStr) => {
                            setHeureFinPause({time: dateStr})
                          }}
                          options={{
                            enableTime: true,
                            noCalendar: true,
                            dateFormat: 'H:i',
                            minTime: heureDebutPause?.time || undefined,
                            maxTime: heureFin?.time || undefined,
                            time_24hr: true,
                          }}
                          className='form-control form-control-solid'
                          placeholder='Heure fin pause'
                          name='horaireFinPause'
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>Jour spécifique</label>
                  <div className='col-lg-8'>
                    <div className='d-flex mb-3 flex-row gap-6'>
                      {dayOrder.map((day) => (
                        <div
                          key={day}
                          className='form-check form-check-custom form-check-solid form-check-sm'
                        >
                          <input
                            className='form-check-input'
                            type='checkbox'
                            value={day}
                            id={day}
                            checked={selectedDay?.includes(day)}
                            onChange={(e) => checkSpecificDay(e.target.value, e.target.checked)}
                          />

                          <label className='form-check-label' htmlFor={day}>
                            {getDayLabel(day)}
                          </label>
                        </div>
                      ))}
                    </div>
                    {selectedDay?.length !== 0 &&
                      [...selectedDay]
                        .sort(
                          (dayA, dayB) =>
                            dayOrder.indexOf(dayA) - dayOrder.indexOf(dayB)
                        )
                        ?.map((dayValue) => (
                        <div className={'row'} key={dayValue}>
                          <label className={'col-lg-4 col-form-label fw-bold fs-6'}>
                            {getDayLabel(dayValue)}
                          </label>
                          <div className='col-lg-8'>
                            <div className='row mb-3'>
                              <div className='col-lg-6 fv-row'>
                                <Flatpickr
                                  value={heureSpec?.[dayValue]?.heureDebut}
                                  onChange={([time], dateStr) => {
                                    setHeureSpec((prev) => ({
                                      ...prev,
                                      [dayValue]: {...prev[dayValue], heureDebut: dateStr},
                                    }))
                                  }}
                                  options={{
                                    enableTime: true,
                                    noCalendar: true,
                                    dateFormat: 'H:i',
                                    time_24hr: true,
                                    maxTime: heureDebutPause?.time, // Ne dois pas dépasser l'horaire de début de pause
                                  }}
                                  className='form-control form-control-solid'
                                  placeholder='Heure début'
                                  name={`horaireDebut_${dayValue}`}
                                />
                              </div>

                              <div className='col-lg-6 fv-row'>
                                <Flatpickr
                                  value={heureSpec?.[dayValue]?.heureFin}
                                  onChange={([time], dateStr) => {
                                    setHeureSpec((prev) => ({
                                      ...prev,
                                      [dayValue]: {...prev[dayValue], heureFin: dateStr},
                                    }))
                                  }}
                                  options={{
                                    enableTime: true,
                                    noCalendar: true,
                                    dateFormat: 'H:i',
                                    minTime: heureSpec?.[dayValue]?.heureDebut || undefined,
                                    time_24hr: true,
                                  }}
                                  className='form-control form-control-solid'
                                  placeholder='Heure fin'
                                  name={`horaireFin_${dayValue}`}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className='card-footer d-flex justify-content-end py-6 px-9'>
                <button
                  type='button'
                  className='btn btn-light me-3'
                  onClick={() => navigate(`/equipes/liste`)}
                >
                  Annuler
                </button>
                <button type='submit' className='btn btn-primary' disabled={disableSaveBtn}>
                  {!loadingOnSave && 'Enregistrer'}
                  {loadingOnSave && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Enregistrement de l'horaire...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </>
        ) : (
          <div className='card-body border-top p-9 text-center'>
            <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px'></span>
          </div>
        )}
      </div>
    </>
  )
}

export default HorairePage